import { Subject } from 'rxjs';

// Event bus for deaf audio state changes
export const DeafAudioEventBus = {
  trackStateChanged$: new Subject<{ isEnabled: boolean }>(),
};
